/**
 * ジャーナルAI API サービス
 */

import { apiClient } from '@/api/client'
import type {
  DailySummaryResponse,
  InterviewQuestion,
  JournalChatRequest,
  JournalChatResponse,
} from '@/api/types/journal'

/**
 * AI質問を生成する
 */
export async function getInterviewQuestions(date: string): Promise<InterviewQuestion[]> {
  const response = await apiClient.get<InterviewQuestion[]>('/journal/questions', {
    params: { date },
  })
  return response.data
}

/**
 * AIとチャットする
 */
export async function sendJournalChat(request: JournalChatRequest): Promise<JournalChatResponse> {
  const response = await apiClient.post<JournalChatResponse>('/journal/chat', request)
  return response.data
}

/**
 * 日次サマリーを取得する
 */
export async function getDailySummary(date: string): Promise<DailySummaryResponse> {
  const response = await apiClient.get<DailySummaryResponse>('/journal/daily-summary', {
    params: { date },
  })
  return response.data
}
